import React from 'react';
import classNames from 'classnames';
import './SignUpLogo.pcss';
import { CustomersAiLogo } from '@mm/icons';

type Props = {
  className?: string;
  color?: string;
};

export const SignUpLogo = ({ className, color }: Props) => (
  <div className={classNames(className, 'sign-up-logo')}>
    <CustomersAiLogo className="sign-up-logo__image" color={color} />
  </div>
);
